import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { getOffice365DocLinks, OFFICE365_DOC_LINK_KEYS } from "../constants/smtpOffice365Docs";

function HintList({ items }) {
  if (!items.length) return null;
  return (
    <Box component="ul" sx={{ m: 0, mt: 0.75, pl: 2.25 }}>
      {items.map((item) => (
        <Box component="li" key={item} sx={{ mb: 0.35 }}>
          <Typography variant="body2" component="span">
            {item}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default function SmtpCredentialsTestHint({ hint, t, language }) {
  if (!hint?.type) return null;

  const isOAuthMicrosoft = hint.type === "oauth_microsoft";
  const isOffice365 = hint.type === "office365" || isOAuthMicrosoft;
  const prefix = isOAuthMicrosoft
    ? "channelForm.smtpUi.authHintOAuthMicrosoft"
    : isOffice365
      ? "channelForm.smtpUi.authHintOffice365"
      : "channelForm.smtpUi.authHintGeneric";

  const checks = [
    hint.loginIncomplete ? t(`${prefix}.loginIncomplete`) : null,
    hint.senderMismatch ? t(`${prefix}.senderMismatch`) : null,
    t(`${prefix}.login`),
    isOAuthMicrosoft ? null : t(`${prefix}.password`),
    isOAuthMicrosoft ? t(`${prefix}.oauthCredentials`) : t(`${prefix}.redenterPassword`),
    isOAuthMicrosoft ? t(`${prefix}.imapPermission`) : null,
    isOAuthMicrosoft ? t(`${prefix}.mailboxAccess`) : null,
    isOAuthMicrosoft ? t(`${prefix}.smtpPasswordOptional`) : null,
    !isOAuthMicrosoft && isOffice365 ? t(`${prefix}.smtpImapEnabled`) : null,
    !isOAuthMicrosoft && isOffice365 ? t(`${prefix}.basicAuth`) : null,
    !isOAuthMicrosoft && isOffice365 ? t(`${prefix}.webLogin`) : null,
    !isOAuthMicrosoft && !isOffice365 ? t(`${prefix}.serverSettings`) : null,
  ].filter(Boolean);

  const docs = isOffice365 ? getOffice365DocLinks(language) : null;
  const docKeys = isOAuthMicrosoft
    ? ["imapAccessAsApp", "appPermissions", "imapPop", "emailApps"]
    : OFFICE365_DOC_LINK_KEYS;

  return (
    <Box sx={{ mt: 1.25 }}>
      <Typography variant="body2" fontWeight={600}>
        {t("channelForm.smtpUi.authHintTitle")}
      </Typography>
      <HintList items={checks} />

      {docs ? (
        <>
          <Typography variant="body2" fontWeight={600} sx={{ mt: 1 }}>
            {t("channelForm.smtpUi.authHintLinksTitle")}
          </Typography>
          <Box component="ul" sx={{ m: 0, mt: 0.75, pl: 2.25 }}>
            {docKeys.map((key) => (
              <Box component="li" key={key} sx={{ mb: 0.35 }}>
                <Link href={docs[key]} target="_blank" rel="noopener noreferrer" variant="body2">
                  {t(`channelForm.smtpUi.authHintLinks.${key}`)}
                </Link>
              </Box>
            ))}
          </Box>
        </>
      ) : null}
    </Box>
  );
}
